var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 490",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffffff;\n      }\n      .st1 {\n        fill: #344733;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 720,
    height: 490,
    rx: 92,
    ry: 92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.025,180.835l-35.34,13.76-.15-31.72,41.57-16.08h29.98v197.13h-36.06v-163.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.895,301.775h-98.35l-2.46-25.64,96.75-130.06h40.12v126.01h31.14v29.69h-31.14v42.15h-36.06v-42.15ZM297.895,272.375v-81.54l-61.7,81.69,61.7-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.575,180.835l-35.34,13.76-.14-31.72,41.57-16.08h29.98v197.13h-36.06v-163.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.645,323.355l64.45-58.51c6.18-5.7,11.73-10.96,16.66-15.79,4.92-4.83,9.07-9.49,12.46-13.98,3.38-4.49,5.99-8.93,7.82-13.32,1.83-4.39,2.75-8.96,2.75-13.69s-.8-8.74-2.39-12.6c-1.59-3.86-3.82-7.17-6.66-9.92-2.85-2.75-6.25-4.9-10.21-6.45-3.96-1.54-8.31-2.32-13.04-2.32s-9.08.77-13.33,2.32c-4.25,1.55-7.99,4.01-11.23,7.39-3.24,3.38-5.84,7.82-7.82,13.33-1.98,5.5-2.97,12.26-2.97,20.28h-35.78c0-9.56,1.33-18.9,3.98-28.03,2.66-9.12,6.83-17.28,12.53-24.48,5.7-7.19,12.99-12.99,21.87-17.38,8.88-4.39,19.5-6.59,31.86-6.59,10.81,0,20.52,1.69,29.11,5.07,8.59,3.38,15.86,7.99,21.8,13.83,5.94,5.84,10.48,12.67,13.61,20.5,3.14,7.82,4.71,16.17,4.71,25.06,0,6.47-.89,12.58-2.68,18.32-1.79,5.75-4.35,11.3-7.68,16.66-3.33,5.36-7.31,10.57-11.95,15.64-4.63,5.07-9.85,10.12-15.64,15.14l-48.52,42.44,16.22-3.48h73.87v31.14h-143.82v-20.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89e48ba14dff2abbae9b4a8857533794.svg";
export { ForwardRef as ReactComponent };